import * as React from "react";
import get from "lodash/get";

import "./Video.css";
import {
  isEditMode,
  onClickSendToMerchant,
} from "../../utils/sendClickToMerchant";
import { interpolate } from "../../utils/string";
import { extractInfluencerAndAdvocate } from "../../utils/share";
import { getHorizontalAlignment } from "../../utils/getHorizontalAlignment";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface VideoProps extends ComponentBaseProps {
  autoPlay?: boolean;
  classNames?: string;
  configName: string;
  muted?: boolean;
  opacity?: number;
  poster?: string;
  data: any;
  source: string;
  playbackRate?: number;
  style?: React.CSSProperties;
  scale?: number;
  videoPositionLeft?: string;
  videoPositionTop?: string;
  videoStyles?: React.CSSProperties;
  // tslint:disable-next-line:no-any
  [otherProps: string]: any;
}

export class Video extends ComponentBase<VideoProps> {
  componentDidMount() {
    const { configName, playbackRate } = this.props;
    const video = document.getElementById(configName) as HTMLVideoElement;

    if (playbackRate && video) {
      video.playbackRate = playbackRate;
    }

    if (this.component && this.props.horizontalAlign) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  componentDidUpdate(prevProps: VideoProps) {
    const { configName, playbackRate = 1 } = this.props;
    const video = document.getElementById(configName) as HTMLVideoElement;

    if (prevProps.playbackRate !== playbackRate && video) {
      video.playbackRate = playbackRate;
    }

    if (
      this.component &&
      prevProps.horizontalAlign !== this.props.horizontalAlign
    ) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  onPlay = () => {
    this.setState({ isPlaying: true });

    return this.component && (this.component as HTMLVideoElement).play();
  };

  onPause = () => {
    this.setState({ isPlaying: false });

    return this.component && (this.component as HTMLVideoElement).pause();
  };

  onUnMute = () => {
    this.setState({ isMuted: false });

    return (
      this.component && ((this.component as HTMLVideoElement).muted = false)
    );
  };

  onMute = () => {
    this.setState({ isMuted: true });

    return (
      this.component && ((this.component as HTMLVideoElement).muted = true)
    );
  };

  render() {
    const { isMuted, isPlaying } = this.state;
    const {
      classNames,
      configName,
      data,
      poster,
      opacity = 0,
      referral,
      share,
      source,
      scale,
      videoPositionLeft,
      videoPositionTop,
      videoStyles,
      config,
    } = this.props;
    const defaultToBlank = !isEditMode();
    const configShareData = get(config, ["data", "share"], {});
    const { advocate, influencer } = extractInfluencerAndAdvocate(
      configShareData,
      referral
    );
    const allData = { ...data, referral, share, advocate, influencer };
    const interpolatedSrc = interpolate(source, allData, defaultToBlank);

    const videoStyle = {
      ...videoStyles,
      transform: `scale(${scale})`,
      left: videoPositionLeft,
      top: videoPositionTop,
    };

    const style = {
      overflow: "hidden",
      ...this.props.style,
    };

    return (
      <div
        className={classNames}
        style={style}
        aria-label={get(this.props, "label", "")}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
      >
        <video
          id={this.props.configName}
          autoPlay={isPlaying}
          controls={false}
          loop={true}
          muted={isMuted}
          poster={poster}
          className="video"
          ref={(video) => (this.component = video)}
          style={videoStyle}
          src={interpolatedSrc}
        >
          Sorry, your browser does not support this video
        </video>
        <div style={{ opacity }} className="video-mask" />
        <div
          className={`video-container ${
            isPlaying ? "is-playing" : "is-not-playing"
          } ${isMuted ? "is-muted" : "is-not-muted"}`}
          onClick={onClickSendToMerchant(configName)}
        >
          <img
            className="play-button"
            src="http://cdn.friendbuy.com/widget/fbt-widget-assets/play-button.svg"
            alt="Play Button"
            onClick={this.onPlay}
          />
          <img
            className="pause-button"
            src="http://cdn.friendbuy.com/widget/fbt-widget-assets/pause-button.svg"
            alt="Pause Button"
            onClick={this.onPause}
          />
          <img
            className="sound-button"
            src="http://cdn.friendbuy.com/widget/fbt-widget-assets/video/mute.svg"
            alt="Sound Button"
            onClick={this.onUnMute}
          />
          <img
            className="mute-button"
            src="http://cdn.friendbuy.com/widget/fbt-widget-assets/video/volume.svg"
            alt="Mute Button"
            onClick={this.onMute}
          />
        </div>
      </div>
    );
  }
}
